import { Card, CardContent, LinearProgress } from "@material-ui/core";
import Axios from "axios";
import React, { Component } from "react";
import { Table } from "react-bootstrap";
import AppConfig from "../../../../config/AppConfig";
import ChartSebaranAPTBerdasarkanJenisA from "./component/ChartSebaranAPTBerdasarkanJenisA";
import ChartSebaranAPTBerdasarkanJenisB from "./component/ChartSebaranAPTBerdasarkanJenisB";
class SebaranSPMI extends Component {
  state = {
    lembaga: "1",
    status: false,
    loading: false,
    data_loaded: false,
    data_chart: [],
    total_data: [],
  };
  onChangeMenu = (e, type) => {
    this.setState({
      [type]: e.target.value,
      status: true,
    });
  };

  modifyStatus = (data) => {
    this.setState({ status: data });
  };

  // Get Data ============================================================================
  getDataChart1() {
    this.setState({
      loading: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    Axios.get(AppConfig.DetailDashboard + "sebaranakreditasi" + session)
      .then((res) => {
        console.log(res.data.result);
        this.setState({
          loading: false,
          data_loaded: true,
          data_chart: res.data.result.data_vokasi,
          total_data: res.data.result.data_belmawa,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  async componentDidMount() {
    this.getDataChart1();
  }

  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let access = userdata.i_idbp;

    let i = 0;
    let list_data_chart = [];

    if (this.state.data_loaded === true) {
      if (access !== 2) {
        for (var index in this.state.total_data) {
          list_data_chart[i] = {
            result: this.state.total_data[index],
            key: index,
          };
          i++;
        }
        // console.log(list_data_chart);
      } else {
        for (var index in this.state.data_chart) {
          list_data_chart[i] = {
            result: this.state.data_chart[index],
            key: index,
          };
          i++;
        }
        // console.log(list_data_chart);
      }
    }

    return (
      <>
        <Card className="mt-10">
          <CardContent>
            <div className="row row-paddingless">
              <div
                className="col-md-12 col-xxl-12"
                style={{ textAlign: "center" }}
              >
                <h3
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Sebaran Akreditasi
                </h3>
                <div className="row mb-5">
                  <div className="col-md-2 offset-md-5">
                    <select
                      name="display"
                      className={`form-control form-control-lg form-control-solid `}
                      style={{ paddingLeft: "0px 20px 0px 20px" }}
                      onChange={(e) => this.onChangeMenu(e, "lembaga")}
                    >
                      <option value="1">Kemendikbud</option>
                      <option value="2">Kementerian Luar</option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="col-md-12 col-xxl-12"
                style={{ textAlign: "center" }}
              >
                <h5
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Sebaran APT Berdasarkan Jenis
                </h5>
              </div>
              <div
                className="col-md-12 col-xxl-12"
                style={{ textAlign: "center" }}
              >
                  <ChartSebaranAPTBerdasarkanJenisB
                    tipe_lembaga={this.state.lembaga}
                    status={this.state.status}
                    parentCallback={this.modifyStatus}
                  />
              </div>
              <br />
            </div>
          </CardContent>
        </Card>
      </>
    );
  }
}
export default SebaranSPMI;
